// extracted by mini-css-extract-plugin
export default {"container":"style_container__0ec59","titleSection":"style_titleSection__KtBaT"};